import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import './style.css';
import { saveCookieConsent } from '../../helpers/cookieConsent';

const CookieBanner = ({ visible, onDecision, onOpenSettings }) => {
  const { t } = useTranslation('cookieConsent');

  if (!visible) return null;

  const acceptAll = () => {
    saveCookieConsent({ analytics: true, marketing: true, functional: true });
    onDecision();
  };

  const rejectNonEssential = () => {
    saveCookieConsent({ analytics: false, marketing: false, functional: false });
    onDecision();
  };

  return (
    <div className="cookie-banner" role="dialog" aria-live="polite" aria-label={t('banner.title')}>
      <div className="cookie-banner__inner">
        <div className="cookie-banner__text">
          <p className="cookie-banner__title">{t('banner.title')}</p>
          <p className="cookie-banner__description">
            {t('banner.description')}{' '}
            <Link to="/cookie-policy" className="cookie-banner__link">
              {t('banner.learnMore')}
            </Link>
          </p>
        </div>

        <div className="cookie-banner__actions">
          <button
            type="button"
            className="cookie-banner__btn cookie-banner__btn--ghost"
            onClick={onOpenSettings}
          >
            {t('banner.cookieSettings')}
          </button>
          <button
            type="button"
            className="cookie-banner__btn cookie-banner__btn--outline"
            onClick={rejectNonEssential}
          >
            {t('banner.rejectNonEssential')}
          </button>
          <button
            type="button"
            className="cookie-banner__btn cookie-banner__btn--primary"
            onClick={acceptAll}
          >
            {t('banner.acceptAll')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
